import { render, staticRenderFns } from "./TableListProductsNucleoSelected.vue?vue&type=template&id=189a913a"
import script from "./TableListProductsNucleoSelected.vue?vue&type=script&lang=js"
export * from "./TableListProductsNucleoSelected.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports